<template>
  <v-container fluid class="relatorios-ciclo">
    <div class="d-flex align-center justify-space-between flex-wrap mb-4">
      <h1 class="text-h5">Relatórios do Ciclo · {{ ano }}</h1>
      <v-btn outlined color="primary" :loading="carregando" @click="carregar">Atualizar</v-btn>
    </div>
    <v-alert v-if="erro" type="error" outlined>{{ erro }}</v-alert>
    <v-card outlined>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="4"><v-autocomplete v-model="regional" :items="regionais" label="Regional" clearable outlined dense hide-details /></v-col>
          <v-col cols="12" md="4"><v-autocomplete v-model="sala" :items="salas" item-text="nome" item-value="municipioId" :label="$store.getters.isParceiro ? 'Sala ou parceiro' : 'Sala'" clearable outlined dense hide-details /></v-col>
          <v-col cols="12" md="4"><v-autocomplete v-model="categoria" :items="categorias" label="Categoria" clearable outlined dense hide-details /></v-col>
        </v-row>
      </v-card-text>
      <v-card-title class="text-subtitle-1">{{ $store.getters.isParceiro ? 'Parceiros' : 'Salas' }} do ciclo · {{ filtrados.length }}</v-card-title>
      <v-data-table :headers="cabecalhos" :items="filtrados" item-key="municipioId" :loading="carregando" :footer-props="{ 'items-per-page-text': 'Salas por página', 'items-per-page-all-text': 'Todas' }" no-data-text="Nenhuma sala ou parceiro encontrado para os filtros selecionados." loading-text="Carregando relatórios...">
        <template v-slot:item.pontuacao="{ item }">{{ item.categoria === 'Ouro' || item.pontuacao == null ? '-' : numero(item.pontuacao) }}</template>
        <template v-slot:item.relatorio="{ item }">
          <v-btn v-if="item.categoria !== 'Ouro' && item.podeEmitirRelatorio" text small color="primary" :to="rotaRelatorio(item)">Relatório final</v-btn>
          <span v-else>-</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { seloFechamentoAPI } from '../API/SeloFechamentoAPI';
import { normalizarDados, numero, mensagemErro } from '../utils';
import { filtrarRelatoriosCiclo } from '../relatoriosCiclo.mjs';

const filtro = chave => ({
  get() { return this.$route.query[chave] || null; },
  set(valor) { const query = { ...this.$route.query }; if (valor) query[chave] = String(valor); else delete query[chave]; this.$router.replace({ query }).catch(() => {}); },
});

export default {
  name: 'SeloRelatoriosCiclo',
  data() { return {
    items: [], carregando: false, erro: '',
    cabecalhos: [{ text: 'Regional', value: 'regional' }, { text: 'Sala ou parceiro', value: 'nome' }, { text: 'Pontos', value: 'pontuacao' }, { text: 'Categoria', value: 'categoria' }, { text: 'Relatório', value: 'relatorio', sortable: false }],
  }; },
  computed: {
    uf() { return String(this.$store.state.uf || '').toUpperCase(); },
    ano() { return 2026; },
    regional: filtro('regional'), sala: filtro('sala'), categoria: filtro('categoria'),
    regionais() { return [...new Set(this.items.map(item => item.regional))].sort((a,b) => a.localeCompare(b,'pt-BR')); },
    categorias() { return [...new Set(this.items.map(item => item.categoria))].sort((a,b) => a.localeCompare(b,'pt-BR')); },
    salas() { return this.items.map(item => ({ nome: item.nome, municipioId: String(item.municipioId) })); },
    filtrados() { return filtrarRelatoriosCiclo(this.items, this); },
  },
  mounted() { this.carregar(); },
  methods: {
    numero,
    rotaRelatorio(item) { return { name: 'selo-relatorio-ciclo', params: { uf: this.uf, ano: this.ano, municipioId: item.municipioId }, query: { ...this.$route.query } }; },
    async carregar() {
      this.carregando = true; this.erro = ''; this.items = [];
      try { const response = await seloFechamentoAPI.relatoriosCiclo(this.uf, this.ano); this.items = normalizarDados(response.data); }
      catch (error) { this.erro = mensagemErro(error); }
      finally { this.carregando = false; }
    },
  },
};
</script>

<style scoped>
.relatorios-ciclo { max-width: 1500px; padding: 24px; }
</style>
